export default function SectionHeading({
  kicker,
  title,
  desc,
  to,
  linkText,
  align = "left",
}: {
  kicker?: string;
  title: string;
  desc?: string;
  to?: string;
  linkText?: string;
  align?: "left" | "center";
}) {
  return (
    <div
      className={`mb-6 flex flex-col gap-4 sm:mb-8 ${
        align === "center" ? "items-center text-center" : "sm:flex-row sm:items-end sm:justify-between"
      }`}
    >
      <div className={align === "center" ? "mx-auto max-w-2xl" : ""}>
        {kicker && (
          <span className="mb-2 inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-wider text-primary-600">
            <i className={align === "center" ? "hidden" : "ri-flashlight-fill"} />
            {kicker}
          </span>
        )}
        <h2 className="font-heading text-2xl leading-tight text-foreground-950 md:text-3xl">{title}</h2>
        {desc && <p className={`mt-2 text-sm leading-relaxed text-foreground-600 md:text-base ${align === "center" ? "mx-auto max-w-xl" : ""}`}>{desc}</p>}
      </div>
      {to && linkText && (
        <a href={to} className="group inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap text-sm font-bold text-primary-600 transition-colors hover:text-primary-700">
          {linkText}
          <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5" />
        </a>
      )}
    </div>
  );
}